import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapSettingsMetaAds = {
  show: async(props) => {
    const { default: MetaAdsSettings } = await import('@/vue_widgets/mlap/settings/meta_ads/index.vue')
    createVueApp(MetaAdsSettings, { props })
  }
}
